import Breathe from '@/components/breathe';
import Layout from '@/components/layout/LayoutWrapper';

const BreathePage = () => {
	return (
		<Layout pageName="breathe" title="Calm - Breathe">
			<Breathe />
		</Layout>
	);
};

export { getServerSideProps } from '@/utils/pageGeneration/getServerSideProps';

export default BreathePage;
